export const PROGRAM_SCANOBAR_IDENTIFIED_FOR_ANALYTICS =
  process.env.API_ENV === 'production'
    ? 'loyalty_program-209'
    : 'loyalty_program-190'
